export const styles = {
  container: {
    display: 'flex',
    // height: '100vh',
    background: '#f5f5f5',
    borderRadius: '20px'
  },
  
  actionsBar: {
    width: '95px',
    borderLeft: '1px solid #e0e0e0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '1rem 0.5rem',
    paddingLeft: '10px',
    gap: '.8rem',
    position: 'sticky',
    top: 0,
    height: '100vh',
    zIndex: 100,
    alignSelf: 'flex-start'
  },
  
  progressContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '0rem',
    background: '#ffffff',
    borderRadius: '15px',
    fontSize: '1rem',
    paddingTop: '5px',
    boxShadow: '4px 4px 2px rgba(0,0,0,0.02)'
  },
  
  progressCircle: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    background: 'conic-gradient(#00A1FF 0% 60%, #e3f5f5 53% 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    color: '#00A1FF'
  },
  
  progressInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.9rem',
    fontWeight: '600'
  },
  
  viewAllTasksButton: {
    marginTop: '0.8rem',
    padding: '0.4rem 0.6rem',
    background: 'white',
    border: 'none',
    borderRadius: '15px',
    fontSize: '0.6rem',
    fontWeight: '400',
    cursor: 'pointer',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    lineHeight: '1.3'
  },
  
  divider: {
    width: '100%',
    height: '1px',
    background: '#e0e0e0'
  },
  
  actionButton: {
    display: 'flex',
    flexDirection: 'column',
    width: '70px',
    alignItems: 'center',
    cursor: 'pointer',
    background: '#ffffff',
    borderRadius: '8px',
    fontSize: '1rem',
    paddingTop: '10px',
    paddingBottom: '10px',
    
    boxShadow: '4px 4px 2px rgba(0,0,0,0.02)'
  },
  
  actionIcon: {
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  
  actionLabel: {
    fontSize: '0.7rem',
    marginTop: '0.3rem',
    fontWeight: '500'
  },
  
  mainContent: {
    flex: 1,
    padding: '1rem',
    marginRight: '0px',
  },
  
  pageTitle: {
    fontSize: '2rem',
    marginBottom: '1rem'
  },
  
  pageDescription: {
    marginBottom: '2rem',
    color: '#666'
  },
  
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 400px',
    gap: '1.5rem',
    alignItems: 'start'
  },
  
  card: {
    background: '#233a67',
    border: 'none',
    borderRadius: '12px',
    padding: '0',
    marginBottom: '1.5rem',
    overflow: 'hidden'
  },
  
  claimHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1.5rem',
    background: '#233a67',
    borderRadius: '12px 12px 0 0'
  },
  
  claimTitle: {
    fontSize: '1.5rem',
    marginBottom: '0rem',
    color: '#ffffff',
    fontWeight: '300'
  },
  
  claimSubtitle: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: '0.85rem'
  },
  
  statsContainer: {
    display: 'flex',
    gap: '1.5rem',
    background: '#3a4e77',
    borderRadius: '8px'
  },
  
  statItem: {
    textAlign: 'center',
    padding: '1rem 2.5rem',
    minWidth: '140px',
    borderRight: '1px solid #233a67'
  },
  
  lastStatItem: {
    textAlign: 'center',
    padding: '1rem 2.5rem',
    minWidth: '140px',
    borderRight: 'none'
  },
  
  statLabel: {
    fontSize: '0.7rem',
    color: '#94a6ca',
    marginBottom: '0.5rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  
  statValue: {
    fontSize: '1.3rem',
    fontWeight: '300',
    color: '#ffffff'
  },
  
  statValuePrimary: {
    fontSize: '1.3rem',
    fontWeight: '300',
    color: '#ffffff'
  },
  
  statValuePositive: {
    fontSize: '1.3rem',
    fontWeight: '300',
    color: '#4dff74',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.3rem'
  },
  
  alertBanner: {
    background: '#233a67',
    borderTop: '1px solid #4a6291',
    padding: '1.2rem 1.5rem',
    borderRadius: '0 0 12px 12px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '1rem',
    margin: '0'
  },
  
  alertIcon: {
    fontSize: '1.5rem',
    color: '#60a5fa',
    marginTop: '0.2rem'
  },
  
  alertTitle: {
    fontWeight: '400',
    marginBottom: '0.3rem',
    color: '#ffffff',
    fontSize: '1.25rem',
    fontStyle: 'italic'
  },
  
  alertDescription: {
    fontSize: '1.25rem',
    color: '#ffffff',
    fontStyle: 'italic'
  },
  
  sectionTitle: {
    fontSize: '1.1rem',
    fontWeight: '600',
    marginBottom: '1.5rem'
  },
  
  recommendationSection: {
    background: 'transparent',
    border: 'none',
    borderRadius: '8px',
    padding: '0',
    marginBottom: '1.5rem',
    position: 'relative'
  },
  
  recommendationHeader: {
    position: 'absolute',
    top: '.5rem',
    right: '1rem'
  },
  
  recommendationTag: {
    background: '#f5f5f5',
    color: '#666',
    padding: '0.5rem 1rem',
    borderRadius: '6px',
    fontSize: '0.85rem',
    fontWeight: '500'
  },
  
  recommendationGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '1rem',
    alignItems: 'end'
  },
  
  recommendationCardAI: {
    background: 'linear-gradient(135deg, #0066FF 0%, #00B4FF 100%)',
    border: 'none',
    borderRadius: '12px',
    padding: '3rem 4px 4px',
    cursor: 'pointer',
    position: 'relative',
    overflow: 'hidden'
  },
  
  recommendationCardNormal: {
    cursor: 'pointer',
    position: 'relative',
    bottom: '2px'
  },
  
  recommendationCard: {
    border: '2px solid rgba(0, 102, 255, 0.1)',
    borderRadius: '12px',
    padding: '1.5rem',
    cursor: 'pointer'
  },
  
  recommendationContent:{
    background: 'white',
    border: '2px dashed #0066FF',
    borderRadius: '12px',
    padding: '1.5rem',
    paddingTop: '2rem',
    color: '#666666',
    backgroundColor: '#fff'
  },
  aiContentCard:{
    color: '#666666',
    border: 'none'
  },
  aiRecommendedBadge: {
    // background: 'rgba(255, 255, 255, 0.2)',
    position: 'absolute',
    top: '.5rem',
    width: 'fit-content',
    color: '#ffffff',
    padding: '0.4rem 0.8rem',
    fontSize: '0.95rem',
    fontWeight: '600',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.3rem',
    marginBottom: '1rem'

  },
  
  recommendationTitle: {
    fontSize: '1.1rem',
    fontWeight: '600',
    marginBottom: '0.8rem',
    color: '#333'
  },
  
  recommendationTitleAI: {
    fontSize: '1.1rem',
    fontWeight: '600',
    marginBottom: '0.8rem',
    color: '#333'
  },
  
  recommendationAmount: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#333',
    marginBottom: '0.8rem'
  },
  
  recommendationAmountAI: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#333',
    marginBottom: '0.8rem'
  },
  
  recommendationDescription: {
    fontSize: '0.85rem',
    color: '#666',
    marginBottom: '1.5rem',
    lineHeight: '1.4'
  },
  
  recommendationDescriptionAI: {
    fontSize: '0.85rem',
    color: 'rgba(0, 0, 0, 0.9)',
    marginBottom: '1.5rem',
    lineHeight: '1.4'
  },
  
  recommendationPayable: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '1rem',
    borderTop: '1px dashed rgba(224, 224, 224, 0.933)',
    marginBottom: '1rem'
  },
  
  recommendationPayableAI: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '1rem',
    borderTop: '1px dashed rgba(224, 224, 224, 0.933)',
    color: '#666666',
    marginBottom: '1rem'
  },
  
  recommendationPayableLabel: {
    fontSize: '0.85rem',
    color: '#666'
  },
  
  recommendationPayableLabelAI: {
    fontSize: '0.85rem',
    color: '#333'
  },
  
  recommendationPayableValue: {
    fontSize: '1rem',
    fontWeight: '600',
    color: '#333'
  },
  
  recommendationPayableValueAI: {
    fontSize: '1rem',
    fontWeight: '600'
  },
  
  submitButtonAI: {
    background: '#0066FF',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    padding: '0.75rem 1.5rem',
    fontSize: '0.9rem',
    fontWeight: '600',
    cursor: 'pointer',
    width: '100%',
    textAlign: 'center'
  },
  
  submitButtonNormal: {
    background: '#e8e8e8',
    color: '#666',
    border: 'none',
    borderRadius: '8px',
    padding: '0.75rem 1.5rem',
    fontSize: '0.9rem',
    fontWeight: '600',
    cursor: 'pointer',
    width: '100%',
    textAlign: 'center'
  },
  
  recommendationDetails: {
    fontSize: '0.85rem'
  },
  
  detailRow: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  
  detailLabel: {
    color: '#666'
  },
  
  detailValue: {
    fontWeight: '500'
  },
  
  intelligenceGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '1rem',
    marginTop: '1.5rem'
  },
  
  intelligenceCard: {
    padding: '1.2rem',
    border: '1px solid rgba(0, 102, 255, 0.1)',
    borderRadius: '12px',
    textAlign: 'center'
  },
  
  intelligenceIcon: {
    width: '50px',
    height: '50px',
    margin: '0 auto 1rem',
    background: 'rgba(0, 102, 255, 0.1)',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.5rem'
  },
  
  intelligenceTitle: {
    fontSize: '0.85rem',
    fontWeight: '600',
    marginBottom: '0.5rem'
  },
  
  intelligenceMetric: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#0066FF',
    marginBottom: '0.3rem'
  },
  
  intelligenceDescription: {
    fontSize: '0.75rem',
    color: '#666'
  },
  
  aiPanel: {
    background: 'white',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    padding: '1.5rem',
    height: 'fit-content'
  },
  
  aiPanelHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.8rem',
    marginBottom: '1.5rem',
    paddingBottom: '1rem',
    borderBottom: '1px solid rgba(0, 102, 255, 0.1)'
  },
  
  aiPanelIcon: {
    width: '40px',
    height: '40px',
    background: 'linear-gradient(135deg, #0066FF 0%, #0052CC 100%)',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontSize: '1.2rem'
  },
  
  aiPanelTitle: {
    fontSize: '1rem',
    fontWeight: '600',
    marginBottom: '0.2rem'
  },
  
  aiPanelSubtitle: {
    fontSize: '0.8rem',
    color: '#666'
  },
  
  messageContainer: {
    marginBottom: '1rem'
  },
  
  message: {
    padding: '1rem',
    borderRadius: '12px',
    background: 'rgba(0, 102, 255, 0.05)',
    border: '1px solid rgba(0, 102, 255, 0.1)',
    marginBottom: '1rem'
  },
  
  messageHeader: {
    fontSize: '0.8rem',
    fontWeight: '600',
    color: '#0066FF',
    marginBottom: '0.5rem'
  },
  
  messageContent: {
    fontSize: '0.9rem',
    lineHeight: '1.5'
  },
  
  messageContentItalic: {
    fontSize: '0.9rem',
    lineHeight: '1.5',
    marginTop: '0.5rem',
    fontStyle: 'italic'
  },
  
  suggestionsContainer: {
    marginTop: '1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem'
  },
  
  suggestionItem: {
    padding: '0.6rem',
    background: 'white',
    border: '1px solid rgba(0, 102, 255, 0.2)',
    borderRadius: '8px',
    fontSize: '0.85rem',
    cursor: 'pointer'
  },
  
  suggestionBullet: {
    color: '#0066FF',
    marginRight: '0.5rem'
  },
  
  chatInputContainer: {
    display: 'flex',
    gap: '0.5rem',
    paddingTop: '1rem',
    borderTop: '1px solid rgba(0, 102, 255, 0.1)'
  },
  
  chatInput: {
    flex: '1',
    padding: '0.8rem 1rem',
    border: '1px solid rgba(0, 102, 255, 0.2)',
    borderRadius: '8px',
    fontSize: '0.9rem',
    outline: 'none'
  },
  
  chatButton: {
    padding: '0.8rem 1.2rem',
    background: '#0066FF',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer'
  }
};
